export function isMaintenancePlan(product: null | string | undefined): boolean {
  return Boolean(product?.toLowerCase().includes("maintenance"));
}
